<template>
  <b-tab>
    <template #title>
      <i class="fas fa-dollar-sign mr-1"></i> Up sell
    </template>
    <b-row class="py-3">
      <b-col>
        <b-button
          pill
          variant="warning"
          v-b-modal:upsell-products-sort-modal
          class="float-right"
        >
          Sort Products
        </b-button>
      </b-col>
    </b-row>
    <b-card>
      <b-form class="form-horizontal col-xs-12" @submit="saveDetails">
        <b-row class="py-2">
          <b-col>
            <b-row
              class="py-2"
              v-for="product of selectedProducts"
              :key="product"
            >
              <b-col cols="1">
                <img style="height: 30px" :src="product.icon.icon" />
              </b-col>
              <b-col>
                {{ product.name }}
              </b-col>
              <b-col>
                <b-button
                  @click="removeProduct(product)"
                  class="float-right"
                  pill
                  variant="danger"
                >
                  Remove
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="py-2">
          <b-col>
            <b-select v-model="selectedProduct">
              <b-select-option-group
                v-for="cat of categories"
                :key="cat._id"
                :label="cat.name"
              >
                <b-select-option
                  v-for="prod of getAvailableProducts(cat.products)"
                  :key="prod._id"
                  :value="prod"
                >
                  {{ prod.name }}
                </b-select-option>
              </b-select-option-group>
            </b-select>
          </b-col>
          <b-col cols="3">
            <b-button
              class="float-right"
              @click="addProduct"
              pill
              variant="success"
              :disabled="!selectedProduct"
            >
              Add Product
            </b-button>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <b-button
              variant="primary"
              type="submit"
              class="float-right mb-1"
              :disabled="loading"
              size="lg"
              pill
            >
              <b-spinner v-if="loading" />
              <span v-else>Save</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <upsell-products-sort-modal
      :products="selectedProducts"
      @done="onSorting"
    />
  </b-tab>
</template>

<script>
import { mapGetters } from "vuex";
import UpsellProductsSortModal from "./upsell-products-sort-modal.vue";
export default {
  name: "availability",
  components: { UpsellProductsSortModal },
  props: ["category"],
  data: () => ({
    selectedProducts: [],
    selectedProduct: null,
  }),
  computed: {
    ...mapGetters("category", ["loading", "categories"]),
  },
  methods: {
    saveDetails(e) {
      e.preventDefault();
      this.$store.dispatch("category/UPDATE_CATEGORY", {
        categoryInfo: {
          upsell: this.selectedProducts.map((p) => p._id),
        },
        categoryId: this.category._id,
        shopId: this.category.shop,
      });
    },
    getAvailableProducts(products) {
      const productIndexes = this.selectedProducts.map((p) => p._id);
      return products.filter((p) => !productIndexes.includes(p._id));
    },
    addProduct() {
      this.selectedProducts.push({
        ...this.selectedProduct,
      });
      this.selectedProduct = null;
    },
    onSorting(sortedProducts) {
      this.selectedProducts = sortedProducts;
    },
    removeProduct(product) {
      this.selectedProducts = this.selectedProducts.filter(
        (p) => p._id !== product._id
      );
    },
  },
  mounted() {
    this.selectedProducts = this.categories
      .map((cat) =>
        cat.products.filter((p) => this.category.upsell.includes(p._id))
      )
      .flat(2);
  },
  watch: {
    category(newVal) {
      if (!newVal || !newVal.upsell) return;
      this.selectedProducts = this.categories
        .map((cat) => cat.products.filter((p) => newVal.upsell.includes(p._id)))
        .flat(2);
    },
  },
};
</script>

<style scoped></style>
